import React, { createContext, useState } from "react";

const ClienteContext = createContext();

const ClienteContextProvider = ({ children }) => {
  const [tipoInscricao, setTipoInscricao] = useState({ descricao: "CNPJ" });
  const [numInscricao, setNumInscricao] = useState("");
  const [numInscricaoEstadual, setNumInscricaoEstadual] = useState("");
  const [numInscricaoMunicipal, setNumInscricaoMunicipal] = useState("");
  const [ccm, setCcm] = useState("");
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [file, setFile] = useState(null);
  const [changeCertificate, setChangeCertificate] = useState({});
  const [loadingCheckbox, setLoadingCheckbox] = useState(false);
  const [checkboxCertificado, setCheckboxCertificado] = useState({
    contador: true,
    cliente: false,
  });
  const [openModalCertificado, setOpenModalCertificado] = useState(false);
  const [passwordCertificate, setPasswordCertificate] = useState("");

  const [pais, setPais] = useState({ codigo: "1058", descricao: "BRASIL" });
  const [cep, setCep] = useState("");
  const [uf, setUf] = useState(null);
  const [cidade, setCidade] = useState(null);
  const [logradouro, setLogradouro] = useState("");
  const [complemento, setComplemento] = useState("");
  const [bairro, setBairro] = useState("");

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  return (
    <ClienteContext.Provider
      value={{
        tipoInscricao,
        setTipoInscricao,
        numInscricao,
        setNumInscricao,
        numInscricaoEstadual,
        setNumInscricaoEstadual,
        numInscricaoMunicipal,
        setNumInscricaoMunicipal,
        ccm,
        setCcm,
        nome,
        setNome,
        email,
        setEmail,
        loadingCheckbox,
        setLoadingCheckbox,
        checkboxCertificado,
        setCheckboxCertificado,
        openModalCertificado,
        setOpenModalCertificado,
        file,
        setFile,
        changeCertificate,
        setChangeCertificate,
        passwordCertificate,
        setPasswordCertificate,

        pais,
        setPais,
        cep,
        setCep,
        uf,
        setUf,
        cidade,
        setCidade,
        logradouro,
        setLogradouro,
        complemento,
        setComplemento,
        bairro,
        setBairro,

        loading,
        setLoading,
        errors,
        setErrors,
      }}
    >
      {children}
    </ClienteContext.Provider>
  );
};

export { ClienteContextProvider, ClienteContext };
